import React from "react";
import {connect} from "react-redux";
import {
	ButtonGroup,
	Breadcrumb,
	Button,
	Col,
	ControlLabel,
	FormControl,
	FormGroup,
	Form,
	Navbar,
	Row,
} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import {Event} from "components/Comet";
import locale from "locale";
import Message from "./Message";
import SendMessageForm from "./SendMessageForm";
import {getClientNickname} from "tools";
import {
    commentsGet,
    commentCreate,
    commentUpdate,
    commentDelete,
} from "apiPlayer";
import {
    commentsDelete,
    commentSwitchToQuestion,
    addClientBan,
    deleteClientBan,
    getClientBan,
} from "api";
import "./style";
import {commentLectorModal} from "../../../../api/player";
import AuthenticationButtonMessage from "./AuthenticationButtonMessage";
import {EventContext} from "../../../context";
import BannedUsersModal from "../BannedUsersModal";

class Comments extends React.Component {
	state = {
		isLoading: true,
        messageById: {},
		messages: [],
		client: null,
		sendMessageText: '',
		sendMessageButtonDisabled: true,
		currentStreamKey: null,
        currentParticipationType: null,
        hasMoreMessages: false,
        clientsBan: [],
		isBannedUsersModalVisible: false,
	};

	static contextType = EventContext;

	constructor(props) {
		super(props);

        this.lectorModal = this.lectorModal.bind(this);
        this.clearMessages = this.clearMessages.bind(this);
		this.updateMessage = this.updateMessage.bind(this);
		this.deleteMessage = this.deleteMessage.bind(this);
		this.deleteMessageChildren = this.deleteMessageChildren.bind(this);

        this.handleAnswered = this.handleAnswered.bind(this);
        this.handleShowLectorModal = this.handleShowLectorModal.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.handleDeleteMessage = this.handleDeleteMessage.bind(this);
		this.handleModerateMessage = this.handleModerateMessage.bind(this);
		this.handleChangeFixed = this.handleChangeFixed.bind(this);

		this.handleGetClientBan = this.handleGetClientBan.bind(this);
		this.handleAddClientBan = this.handleAddClientBan.bind(this);
		this.handleDeleteClientBan = this.handleDeleteClientBan.bind(this);
		this.handleCheckUserBan = this.handleCheckUserBan.bind(this);

		const {event} = props;
		this.state = {
			...this.state,
			currentStreamKey: event.stream?.[0]?.streamKey || null,
		};
	}

	componentDidMount() {
		this.fetchMessages();
		this.handleGetClientBan();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const streamChanged = this.state.currentStreamKey !== prevState.currentStreamKey;
        const participationTypeChanged = this.state.currentParticipationType !== prevState.currentParticipationType;

		if (!streamChanged && !participationTypeChanged) {
			return;
		}

		this.fetchMessages({isResetUntilId: true});
	}

	fetchMessages({append = false, isResetUntilId = false, offset = 0} = {}) {
		const {event: {eventKey, stream}} = this.props;
		const eventStreams = stream || [];
		const commentRooms = eventStreams.map(({ commentRoom, streamKey }) => ({ ...commentRoom, streamKey }));
		const { currentStreamKey, currentParticipationType } = this.state;
        const messageLimit = 100;
		const roomsKeys = commentRooms.filter(({ streamKey }) => !currentStreamKey || streamKey === currentStreamKey).map(({ roomKey }) => roomKey);
        const params = {
			offset,
            limit: messageLimit,
			roomsKeys,
        };

		if (null !== currentStreamKey) {
			params.streamKey = currentStreamKey;
		}

        if (null !== currentParticipationType) {
			params.participationType = currentParticipationType;
		}

		this.setState({isLoading: true});
		commentsGet(eventKey, params)
			.then(messages => {
                let hasMoreMessages = messages.length === messageLimit;
                let messageById = {};
                if (append) {
                    messageById = Object.assign({}, this.state.messageById);
                }
                messages.forEach(message => {
                    messageById[message.id] = message;
                    message.children.forEach(message => {
                        messageById[message.id] = message;
                    })
                });
                if (append) {
                    messages = this.state.messages.concat(
                        messages.filter(({id}) =>
                            -1 === this.state.messages.findIndex(m => m.id === id)
                        )
                    );
                }
                this.setState({messages, messageById, hasMoreMessages});
            })
			.catch(() => {})
			.then(() => this.setState({isLoading: false}))
		;
	}

    lectorModal(message) {
		this.context.setLectorCommentId(parseInt(message?.id));
    }
	updateMessage(message) {
		const {event} = this.props;
		const {currentStreamKey} = this.state;

		switch (currentStreamKey) {
			case null:
				break;
			case '':
				if (message.streamId) {
					return;
				}
				break;
			default:
				const currentStream = event.stream.find(s => s.streamKey === currentStreamKey);
				if (currentStream?.commentRoom?.id !== message.roomId) {
					return;
				}
		}

        let messageById = Object.assign({}, this.state.messageById);
        let messages = this.state.messages.slice();
        let collection = messages;

        if (message.parentId) {
            let parentMessage = messageById[message.parentId];
            if (!parentMessage) {
                return console.warn('Cant find parent message', message);
            }
            collection = parentMessage.children = parentMessage.children.slice();
        }

        if (messageById[message.id]) { // update
            delete message.children;
            message = Object.assign({}, messageById[message.id], message);
            let index = collection.findIndex(({id}) => id === message.id);
            if (-1 === index) {
                collection.push(message);
            } else {
                collection[index] = message;
            }
        } else { // create
            collection.push(message)
        }

        messageById[message.id] = message;
        this.setState({messages, messageById});
	}
	deleteMessage(message) {
		const messages = this.state.messages.slice();
		const index = messages.findIndex(m => m.id === parseInt(message.id));
		if(index >= 0) {
			messages.splice(index, 1);
			this.setState({messages});
		}
	}
	deleteMessageChildren({messageId, parentMessageId}) {
		const messages = this.state.messages.map((currentMessage) => {
			if (currentMessage.id === parentMessageId) {
				const updatedChildren = currentMessage.children?.filter(({id}) => id !== messageId) || [];
				currentMessage.children = updatedChildren;
				
				const updatedParent = {...currentMessage, children: updatedChildren};
				this.setState((prevState) => ({
					messageById: {
						...prevState.messageById,
						[parentMessageId]: updatedParent,
					}
				}));
	
				return updatedParent;
			}
	
			return currentMessage;
		});
	
		this.setState({messages});
	}

	clearMessages() {
		this.setState({messages: []});
	}

    handleAnswered(message) {
        const {event: {eventKey, eventPassword}} = this.props;
        return commentUpdate(eventPassword, message.id, {chatPassword: eventPassword, answered: !message.answered});
    }
    handleShowLectorModal(message) {
        const {event: {eventKey, eventPassword}} = this.props;
        if (this.context.lectorCommentId === message.id) {
            return commentLectorModal(eventKey, eventPassword, null, 'moderator');
        }
        return commentLectorModal(eventKey, eventPassword, message.id, 'moderator');
    }
	handleDeleteMessage({message, parentMessageId = null}) {
		const {event: {eventKey, eventPassword}} = this.props;
		commentDelete(eventPassword, message.id, {chatPassword: eventPassword})
			.then(message => {
				parentMessageId
					? this.deleteMessageChildren({messageId: parseInt(message.id), parentMessageId})
					: this.deleteMessage(message);
			});
	}
	handleModerateMessage(message) {
		const {event: {eventKey, eventPassword}} = this.props;
        return commentUpdate(eventPassword, message.id, {chatPassword: eventPassword, moderate: !message.moderate})
			.then(message => this.updateMessage(message));
	}
	handleChangeFixed(message) {
		const {event: {eventKey, eventPassword}} = this.props;
        return commentUpdate(eventPassword, message.id, {chatPassword: eventPassword, fixed: !message.fixed})
			.then(message => this.updateMessage(message));
	}

	async handleGetClientBan() {
		const {event: {eventPassword}} = this.props;

		try {
			const response = await getClientBan(eventPassword);
			this.setState({ clientsBan: response });
		} catch(error) {
			console.error(error);
		}
	}
	async handleAddClientBan(clientRegistration) {
		const {event: {eventPassword, moduleAuth}} = this.props;

		if(!confirm(locale('client.ban.confirm', {nickname: getClientNickname(clientRegistration, moduleAuth.nickname)}))) {
            return;
        }

		try {
			const response = await addClientBan(eventPassword, clientRegistration.id);
			this.setState({ clientsBan: response });
			alert(locale('client.ban.success', {username: getClientNickname(clientRegistration, moduleAuth.nickname)}));
			this.handleGetClientBan();
		} catch(error) {
			console.error(error);
		}
	}
	async handleDeleteClientBan(clientRegistration) {
		const {event: {eventPassword, moduleAuth}} = this.props;

		if(!confirm(locale('client.unban.confirm', {nickname: getClientNickname(clientRegistration, moduleAuth.nickname)}))) {
            return;
        }

        try {
			await deleteClientBan(eventPassword, clientRegistration.id);
			alert(locale('client.unban.success', { username: getClientNickname(clientRegistration, moduleAuth.nickname) }));
			this.handleGetClientBan();
		} catch(error) {
			console.error(error);
		}
	}

	removeAllMessages() {
		const {event: {eventPassword}} = this.props;

		if (!confirm('Вы действительно хотите удалить все сообщения?')) {
			return;
		}

        return commentsDelete(eventPassword);
	}
    handleSwitchToQuestion(message) {
        const {event: {eventPassword}} = this.props;

        return commentSwitchToQuestion(eventPassword, message.id);
    }

	handleSendMessage(message) {
		const {event: {eventKey, eventPassword, stream}} = this.props;
		const {currentStreamKey} = this.state;

		const data = Object.assign({chatPassword: eventPassword}, message);
		if (currentStreamKey) {
			data.streamKey = currentStreamKey;
		}

		const currentStream = (stream || []).find(({streamKey}) => streamKey === currentStreamKey);

		if (currentStream?.commentRoom) {
			return commentCreate(currentStream.commentRoom.roomKey, data);
		}
        
	}

	handleCheckUserBan(message) {
		if (!this.state.clientsBan.length) {
			return false;
		}

		return !!this.state.clientsBan?.find(({client}) => client.id === (message.clientRegistration.id ?? message.client.id))
	}

	render() {
		const {event, client} = this.props;
        const {eventPassword, participationType} = event;
		let {messages, hasMoreMessages} = this.state;
		const {isLoading, currentStreamKey, currentParticipationType} = this.state;
        const isHybrid = participationType === "hybrid";

        const getOrderCallback = () => {
            return (a, b) => a.fixed !== b.fixed ? b.fixed - a.fixed : b.time - a.time;
        };

		return (
			<section style={{marginBottom: 70}}>
				<Row>
					<Col xs={6}>
						<Breadcrumb>
							<LinkContainer to={`/event/${eventPassword}`}><Breadcrumb.Item>{locale('mainMenu.interactive')}</Breadcrumb.Item></LinkContainer>
							<Breadcrumb.Item active>{locale('mainMenu.chats')}</Breadcrumb.Item>
						</Breadcrumb>
					</Col>
					<Col xs={6}>
						<div style={{textAlign: 'right'}}>
							<ButtonGroup style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end'}}>
                                <Button href={`/chat/${eventPassword}/comments`} target="_blank">Экран ведущего</Button>
								<Button onClick={() => this.setState({isBannedUsersModalVisible: true})}>Заблокированные пользователи</Button>
								<Button href={`/api/cp/event/${eventPassword}/comment/archive.xlsx`} target="_blank">Скачать архив</Button>
								<Button onClick={() => this.removeAllMessages()} bsStyle="danger">Удалить все сообщения</Button>
							</ButtonGroup>
						</div>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<Form inline>
							{event.stream.length > 1 && <FormGroup style={{marginRight: 5}}>
								<ControlLabel>Зал</ControlLabel>{' '}
								<FormControl
									componentClass="select"
									value={null === currentStreamKey ? 'null' : currentStreamKey}
									onChange={({target:{value}}) => this.setState({currentStreamKey: 'null' === value ? null : value})}
								>
									<option value="null">[Все]</option>
									{/* <option value="">[Вне зала]</option> */}
									{event.stream.map((stream) => <option value={stream.streamKey} key={stream.streamKey}>{stream.description_ru}</option>)}
								</FormControl>
							</FormGroup>}
                            {isHybrid && <FormGroup style={{marginRight: 5}}>
                                <ControlLabel>Формат зрителя</ControlLabel>{' '}
                                <FormControl
                                    componentClass="select"
                                    value={null === currentParticipationType ? 'null' : currentParticipationType}
                                    onChange={({target: {value}}) => this.setState({currentParticipationType: 'null' === value ? null : value})}
                                >
                                    <option value="null">[Все]</option>
                                    <option value="online">От онлайн-зрителя</option>
                                    <option value="offline">От офлайн-зрителя</option>
                                </FormControl>
                            </FormGroup>}
						</Form>
					</Col>
				</Row>

				<Event event="create:comment/message" handler={this.updateMessage} />
				<Event event="update:comment/message" handler={this.updateMessage} />
				<Event event="delete:comment/message" handler={this.deleteMessage} />
				<Event event="clear:comment/message" handler={this.clearMessages} />
                <Event event="lectorModal:comment/message" handler={this.lectorModal} />
                <Event event="create-from-question:comment/message" handler={this.updateMessage} />

				{messages.sort(getOrderCallback()).map(message =>
					<Message
                        key={message.id}
                        type="comment"
						message={message}
						client={client}
						onDelete={(message) => this.handleDeleteMessage({message})}
						onModerate={this.handleModerateMessage}
						onClientBan={this.handleAddClientBan}
						onDeleteClientBan={this.handleDeleteClientBan}
						onChangeFixed={this.handleChangeFixed}
						onSendAnswer={this.handleSendMessage}
                        onAnswered={this.handleAnswered}
						onShowLectorModal={this.handleShowLectorModal}
						isLectorMessage={this.context.lectorCommentId === message.id}
						isUserBanned={this.handleCheckUserBan(message)}
                        onSwitchTo={this.handleSwitchToQuestion.bind(this)}
                        isHybrid={isHybrid}
                    >
						{message.children?.sort((a, b) => a.time - b.time).map(child =>
							<Message
                                key={child.id}
                                type="comment"
								message={child}
								client={client}
								parentMessage={message}
								onDelete={(childMessage) => this.handleDeleteMessage({message: childMessage, parentMessageId: message.id})}
								onModerate={this.handleModerateMessage}
								onClientBan={this.handleAddClientBan}
								onDeleteClientBan={this.handleDeleteClientBan}
								isLectorMessage={this.context.lectorCommentId === child.id}
								isUserBanned={this.handleCheckUserBan(child)}
                                onSwitchTo={this.handleSwitchToQuestion.bind(this)}
                                isHybrid={isHybrid}
                            />
						)}
					</Message>
				)}

                {hasMoreMessages && <p style={{textAlign: 'center'}}>
                    <Button bsStyle="primary" disabled={isLoading} onClick={() => this.fetchMessages({append: true, offset: messages.length})}>Загрузить ещё</Button>
                </p>}

				<Navbar fixedBottom fluid className="message-send-container">
					{client
                        ? <SendMessageForm event={event} client={client} onSubmit={this.handleSendMessage} />
						: <AuthenticationButtonMessage />
					}
				</Navbar>

				<BannedUsersModal
					users={this.state.clientsBan}
					isModalVisible={this.state.isBannedUsersModalVisible}
					onHide={() => this.setState({isBannedUsersModalVisible: false})}
					onDeleteClientBan={this.handleDeleteClientBan}
				/>
			</section>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent,
		client: store.client
	};
};

export default connect(mapStateToProps)(Comments);
